import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { smartFillRoutes } from './App';
import './index.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Smart Fill root element was not found.');
}

const router = createBrowserRouter(smartFillRoutes);

createRoot(container).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);
